"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = _interopRequireDefault(require("./constants"));
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
var _lodash = require("lodash");
var _webClientStore = require("web-client-store");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let {
  Session,
  Indexed
} = _webClientStore.WebClientStore;
let {
  URLs,
  INDEXED_KEYS,
  SESSION_KEYS
} = _constants.default;
class ListItemHandler extends _ApiHandler.default {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty(this, "fetchCurrencies", () => {
      return new Promise(async (resolve, reject) => {
        this.getInstance().get(URLs.LIST_ITEMS_LIST.CURRENCIES).then(response => {
          console.log("response:", response);
          let activeOnly = response.data.filter((curr, index) => {
            return curr.status === 'ac';
          });
          console.log("active Only:", activeOnly);
          resolve(activeOnly);
        }).catch(err => reject(err));
      });
    });
    _defineProperty(this, "getCurrencies", function () {
      let unset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this.cachedResponse(unset, INDEXED_KEYS.CURRENCIES, _this.fetchCurrencies);
    });
    _defineProperty(this, "fetchAcctTypes", () => {
      return new Promise(async (resolve, reject) => {
        this.getInstance().get(URLs.LIST_ITEMS_LIST.ACCNT_TYPES).then(response => {
          console.log("response:", response);
          let activeOnly = response.data.filter((curr, index) => {
            return curr.status === 'ac';
          });
          console.log("active Only:", activeOnly);
          resolve(activeOnly);
        }).catch(err => reject(err));
      });
    });
    _defineProperty(this, "getAcctTypes", function () {
      let unset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this.cachedResponse(unset, INDEXED_KEYS.ACCT_TYPES, _this.fetchAcctTypes);
    });
    _defineProperty(this, "syncTranType", function (by, val) {
      let tag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'B';
      return new Promise(async (resolve, reject) => {
        let url = URLs.TRAN_TYPES + '/sync-' + by;
        let payload = {
          tag: tag
        };
        if (by === 'ac') {
          payload.acType = val;
        } else if (by === 'tran') {
          payload.tranType = val;
        } else {
          reject({
            type: 'timeout',
            message: 'Invalid [by] supplied'
          });
        }
        _this.getInstance().post(url, payload).then(response => {
          resolve({
            type: response === 200 ? 'success' : 'warning',
            message: response.message
          });
        }).catch(err => _this.defaultErrorHandler(err, reject, 'An error occured while syncing transaction type. Please check console.'));
      });
    });
    _defineProperty(this, "deleteTranType", (by, val) => {
      return new Promise((resolve, reject) => {
        let url = URLs.TRAN_TYPES + '/delete-' + by;
        let payload = {};
        if (by === 'ac') {
          payload.acType = val;
        } else if (by === 'tran') {
          payload.tranType = val;
        } else {
          reject({
            type: 'timeout',
            message: 'Invalid [by] supplied'
          });
        }
        this.getInstance().post(url, payload).then(response => {
          resolve({
            type: response === 200 ? 'success' : 'warning',
            message: response.message
          });
        }).catch(err => this.defaultErrorHandler(err, reject, 'An error occured while deleting transaction type. Please check console.'));
      });
    });
    _defineProperty(this, "getTranTypesByAcCached", function (type) {
      let unset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.cachedResponse(unset, INDEXED_KEYS.ACCOUNT_TYPE_TRAN_TYPES + "_" + type, _this.getTranTypesByAc, [type]);
    });
    _defineProperty(this, "getTranTypesByAc", function (type) {
      let cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise((resolve, reject) => {
        let retrieveFrom = URLs.TRAN_TYPES + '/ac';
        // let type = 'DEF'; //default value
        // if (Session.get(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE)) {
        // 	type = Session.get(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE);
        // }
        _this.getInstance()
        //TODO: Instead of calling right away; check if value can be
        // retrieved from cache first
        .post(retrieveFrom, {
          acType: type
        }).then(response => {
          //TODO: Use cache signature
          Indexed.setAsync(INDEXED_KEYS.TRAN_TYPES, response.data).then(value => {
            resolve(value);
          }).catch(err => {
            console.log(err);
            reject({
              type: 'error',
              message: err.message
            });
          });
        }).catch(err => _this.defaultErrorHandler(err, reject, 'An error occured while fetching account types from server. Please check console.'));
      });
    });
    _defineProperty(this, "getLists", async () => {
      return new Promise((resolve, reject) => {
        let url = URLs.LIST_ITEMS_LIST.LIST_MAJOR;
        //this.nav.showOverlay();
        this.getInstance().get(url).then(response => {
          resolve(response);
        }).catch(error => {
          console.error(error);
          //this.showError('Error: Could not be able to retrieve major list');
          reject('error');
          // resolve({ data: [] })
        }).finally(() => {
          //this.nav.hideOverlay();
        });
      });
    });
    _defineProperty(this, "getTranTypes", async type => {
      return new Promise((resolve, reject) => {
        let url = URLs.TRAN_TYPES + '/ac';
        //this.nav.showOverlay();
        console.log('sending request to url', url);
        this.getInstance().post(url, {
          acType: type
        }).then(response => {
          console.log('response', response);
          resolve(response);
        }).catch(error => {
          console.error(error);
          //this.showError('Error: Could not be able to retrieve transaction types');
          reject('error');
          // resolve({ data: [] })
        }).finally(() => {
          //this.nav.hideOverlay();
        });
      });
    });
    _defineProperty(this, "refreshListItemGrid", async listCode => {
      return new Promise((resolve, reject) => {
        let url = "".concat(URLs.LIST_ITEMS_LIST.BASE, "/").concat(listCode);
        //this.nav.showOverlay();;
        this.getInstance().get(url).then(response => {
          resolve(response);
        }).catch(error => {
          console.error(error);
          //this.showError('Error: Could not be able to retrieve list items');
          reject('error');
        }).finally(() => {
          //this.nav.hideOverlay();
        });
      });
    });
    _defineProperty(this, "deleteSelection", (rowsToDelete, status) => {
      return new Promise((resolve, reject) => {
        let selected = rowsToDelete.reduce((arr, item) => {
          arr.push({
            _id: item._id,
            status
          });
          return arr;
        }, []);
        let deleteItemsURL = URLs.LIST_ITEMS + '/deleteitems';
        //this.nav.showOverlay();
        this.getInstance().post(deleteItemsURL, selected).then(response => {
          resolve(response);
        }).catch(error => {
          console.error(error);
          //this.showError('Error: Could not delete the list item(s)')
          // reject('error');
        }).finally(() => {
          //this.nav.hideOverlay();
        });
      });
    });
    _defineProperty(this, "deleteMajor", async () => {
      let _selected = this.state.selected;
      if (_selected.code !== 'default') {
        // this.setState({ enabledDeleteMajor: false, openOverlay: true })
        let deleteItemsURL = URLs.LIST_ITEMS + '/' + _selected._id;
        await getInstance().patch(deleteItemsURL, {
          status: 'in'
        }).then(response => {
          // this.props.enqueueSnackbar('list deleted successfully', {
          // 	variant : 'success'
          // });
        }).catch(error => {
          console.log(error);
          // this.props.enqueueSnackbar('Error: Could not delete the list', {
          // 	variant : 'error'
          // });
        });
        // this.setState({ openOverlay: false, rowsSelected: [] });
        // this.handleGetLists()
      }
    });
    _defineProperty(this, "enableMajor", async () => {
      let _selected = this.state.selected;
      if (_selected.code !== 'default') {
        // this.setState({ enabledEnableMajor: false, openOverlay: true })
        let deleteItemsURL = URLs.LIST_ITEMS + '/' + _selected._id;
        await getInstance().patch(deleteItemsURL, {
          status: 'ac'
        }).then(response => {
          // this.props.enqueueSnackbar('list Enabled successfully', {
          // 	variant : 'success'
          // });
        }).catch(error => {
          console.log(error);
          // this.props.enqueueSnackbar('Error: Could not enable the list', {
          // 	variant : 'error'
          // });
        });
        // this.setState({ openOverlay: false, rowsSelected: [] });
        // this.handleGetLists()
      }
    });
  }
}
exports.default = ListItemHandler;